import { folderJSpath } from './utilities/folderJSpath'

export const GLOBAL_VARIABLES = {
  landingConfig: `${folderJSpath}configuracion.json`,
  idTagDelioClient:
    '29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953abe4cb254380fee21da1e87e8c82a173c2256c0940ada1f402a8e36cb8005bad32093067d94cc4675fdd384b4cf3b0d3ef3a564a38ac549f13962d8757b81ddc8911cbae277739299386b326957a5d502',
  idTagVisit: 'd3795c7889a89c2af249c3baf07a499b',
  idTagConversion: '55d42605642e2c273277c7d2fad0351b',
  priorityIVR: 'https://t.womtp.com/slider/c/mapfre/es/priiority/priorityIVR.js',
  libraries: {
    DAL: 'https://ws.walmeric.com/static/dft/dist/v1/dal.js',
    DCL: 'https://ws.walmeric.com/static/js/dev/v1/dcl.js?idTag=29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953abe4cb254380fee21da1e87e8c82a173c2256c0940ada1f402a8e36cb8005bad32093067d94cc4675fdd384b4cf3b0d3ef3a564a38ac549f13962d8757b81ddc8911cbae277739299386b326957a5d502',
    DRP: 'https://ws.walmeric.com/static/dft/dist/v2/drp.js',
    jquery: 'https://t.womtp.com/slider/c/mapfre/es/satellite_landings/librerias/jquery.min.js',
    jqueryUi: 'https://t.womtp.com/slider/c/mapfre/es/satellite_landings/librerias/jquery-ui.js',
    swiper: 'https://t.womtp.com/slider/c/mapfre/es/satellite_landings/librerias/swiper.min.js',
    bootstrap: 'https://t.womtp.com/slider/c/mapfre/es/satellite_landings/librerias/bootstrap.min.js',
    walmeric: `${folderJSpath}js/landing_funtions/dist/walmeric.js`,
    merkleJsFile: folderJSpath + 'js/merkle.js'
  }
}

export const DICTIONARY_CONFIG = {
  serviceName: 'https://ws.walmeric.com/provision/wsVars/getVar.html?',
  idTag: `idTag=${GLOBAL_VARIABLES.idTagDelioClient}`,
  dictionaryName: '&name=CONFIG_LANDINGS_MAPFRE'
}
